import { render } from "./HospitalOverview.vue?vue&type=template&id=0b3640ac&scoped=true&ts=true"
import script from "./HospitalOverview.vue?vue&type=script&lang=ts"
export * from "./HospitalOverview.vue?vue&type=script&lang=ts"

import "./HospitalOverview.vue?vue&type=style&index=0&id=0b3640ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3640ac"]])

export default __exports__